import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import DocumentRepository from '../configuration/documentRepository/DocumentRepository'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

// S152/S153 (historia 170, HU-05): route shell of the Document repository screen, same pattern as
// MainBomLibrary/MainInspection. Access is gated upstream (LeftMenu + MainMenuPermissionController);
// this shell assumes the caller already authorized DOCUMENT_REPOSITORY.
const MainDocumentRepository = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Document repository'),
      component: <DocumentRepository />
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainDocumentRepository
